<template>
	<div id="app">
		<top-header @toggleTheme="toggleTheme"></top-header>
		<router-view></router-view>
		<player></player>
	</div>
</template>

<script>
import TopHeader from '@/components/TopHeader'
import Player from '@/components/globals/Player'
import {EventBus} from './main.js';
import RadioTheme from './theme';

export default {
	name: 'app',
	components: { TopHeader, Player },
	data: () => ({
	}),
	methods: {
		setPageTitle (title) {
			document.getElementsByTagName('title')[0].innerText = `Madnight Radio - ${title}`;
		},

		toggleTheme (toggle) {
			if (toggle === true) {
				document.body.classList.add("is-dark");
			} else {
				document.body.classList.remove("is-dark");
			}
		}
	},

	beforeMount () {
		RadioTheme.loadTheme();
	},

	mounted () {
		EventBus.$on("toggleTheme", this.toggleTheme);
		EventBus.$emit("toggleTheme", RadioTheme.isDarkModeEnabled());
	}
}
</script>

<style lang="scss">
	@import '~bulma/sass/base/_all';
	@import '~bulma/sass/grid/columns';
	@import '~bulma/sass/elements/title';
	@import '~bulma/sass/elements/content';
	@import '~bulma/sass/elements/other';
	@import '~bulma/sass/elements/button';
	@import '~bulma/sass/elements/tag';
	@import '~bulma/sass/components/modal';
	@import '~bulma/sass/layout/hero';

  #app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding-bottom: 65px;

    & > .router-view {
      flex: 1;
		}
	}
</style>



// WEBPACK FOOTER //
// App.vue?397ab970